// Shared schema.org entities. Every page's JSON-LD graph (components/SEO.jsx)
// includes organizationSchema; other entities point to it by @id.
import { SITE, canonicalFor } from "@/lib/site";
import { COMPANY, GOOGLE_LISTING } from "@/data/content";

export const ORG_ID = `${SITE}/#organization`;
export const WEBSITE_ID = `${SITE}/#website`;

export const AREA_SERVED = [
  { "@type": "Country", name: "India" },
  { "@type": "Country", name: "United States" },
  { "@type": "Country", name: "United Arab Emirates" },
];

export const organizationSchema = {
  "@type": ["Organization", "ProfessionalService"],
  "@id": ORG_ID,
  name: COMPANY.name,
  url: `${SITE}/`,
  logo: { "@type": "ImageObject", url: `${SITE}/orina-logo-512.png`, width: 512, height: 512 },
  image: `${SITE}/og-image.png`,
  description:
    "Orina Enterprise is an e-commerce agency in Mumbai, India. It onboards and manages seller accounts on Amazon, Flipkart, Meesho, JioMart, Myntra, Nykaa, AJIO, Tata CLiQ, Blinkit, Zepto, Instamart, Amazon.com, Walmart, Amazon.ae and Noon, and builds e-commerce websites and apps.",
  email: COMPANY.email,
  telephone: COMPANY.phoneE164,
  priceRange: "₹₹",
  address: {
    "@type": "PostalAddress",
    streetAddress: "5th floor, 307, Chincholi Bunder Road, Mindspace, Malad West",
    addressLocality: "Mumbai",
    addressRegion: "Maharashtra",
    postalCode: "400064",
    addressCountry: "IN",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      opens: "10:00",
      closes: "19:00",
    },
  ],
  hasMap: GOOGLE_LISTING.mapsUrl,
  areaServed: AREA_SERVED,
  knowsLanguage: ["en", "hi"],
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: COMPANY.phoneE164,
      contactType: "sales",
      areaServed: ["IN", "US", "AE"],
      availableLanguage: ["English", "Hindi"],
    },
    {
      "@type": "ContactPoint",
      telephone: COMPANY.whatsappE164,
      contactType: "customer service",
      contactOption: "WhatsApp",
      areaServed: ["IN", "US", "AE"],
      availableLanguage: ["English", "Hindi"],
    },
  ],
  knowsAbout: [
    "Amazon seller account management",
    "Flipkart seller onboarding",
    "Meesho seller management",
    "Quick commerce onboarding (Blinkit, Zepto, Instamart)",
    "Marketplace listing optimization and A+ content",
    "Marketplace advertising (Amazon Ads, Flipkart Ads)",
    "Walmart Marketplace",
    "Amazon.ae and Noon (UAE)",
    "Shopify and e-commerce website development",
  ],
  sameAs: [
    "https://www.linkedin.com/company/orina-enterprise",
    "https://www.instagram.com/orina_enterprise/",
    "https://www.facebook.com/p/Orina-Enterprise-61583540661975/",
    GOOGLE_LISTING.mapsUrl,
  ],
};

// A Service entity provided by the organization (used on service pages).
export const serviceSchema = ({ name, description, path, serviceType, areaServed = AREA_SERVED }) => ({
  "@type": "Service",
  "@id": `${canonicalFor(path)}#service`,
  name,
  description,
  url: canonicalFor(path),
  serviceType: serviceType || name,
  provider: { "@id": ORG_ID },
  areaServed,
});

export const faqSchema = (faqs) => ({
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
